module.exports = __webpack_public_path__ + "img/jpg.9a48fd7a.png";